import { useSelector } from 'react-redux';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import colors from '../../../../../constants/colors';
import AppSpinner from '../../../../components/AppSpinner';
import Plant from './IconBlock/Plant';
import LastThreeMonthsModifiedObligations from './IconBlock/LastThreeMonthsModifiedObligations';

export default function IconListBlock({ elementID }) {
  const resLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1
  );
  const resLevel2 = useSelector(
    (state) => state.currentPage?.elementLevels?.level2
  );

  return (
    <>
      {resLevel2 ? (
        <Container>
          <IconContainer>
            <Plant elementID={elementID} />
            <LastThreeMonthsModifiedObligations elementID={elementID} />
          </IconContainer>
          <HexContainer>{resLevel1[elementID]?.hex}</HexContainer>
        </Container>
      ) : (
        <div>
          <AppNoInfo iconSize={20}>
            <AppSpinner>
              <AppRemixIcon icon="loader-4" color={colors.primaryLight} />
            </AppSpinner>
          </AppNoInfo>
        </div>
      )}
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 6px;
  height: 20px;
  align-items: center;
`;
const IconContainer = styled.div`
  display: grid;
  padding-left: 6px;
  grid-template-columns: 20px 20px;
  grid-template-rows: 20px 20px 20px;
  height: 60px;
`;
const HexContainer = styled.div`
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  color: ${colors.primaryLight};
  font-size: 10px;
`;
